/**
 * Sort function for names, sorted by last name first, then first name
 *
 * @param {Object} a - First object to compare
 * @param {Object} b - Second object to compare
 * @returns {number} Sort order (-1, 0, 1)
 */
export const sortByLastFirstName = (a, b) => {
  const o1 = a.lastName?.toLowerCase() || "";
  const o2 = b.lastName?.toLowerCase() || "";

  const p1 = a.firstName?.toLowerCase() || "";
  const p2 = b.firstName?.toLowerCase() || "";

  if (o1 < o2) return -1;
  if (o1 > o2) return 1;
  if (p1 < p2) return -1;
  if (p1 > p2) return 1;
  return 0;
};

/**
 * Sort function for full names provided as a single string
 *
 * @param {Object} a - First object to compare
 * @param {Object} b - Second object to compare
 * @param {string} nameField - The field containing the full name
 * @returns {number} Sort order (-1, 0, 1)
 */
export const sortByFullName = (a, b, nameField = "fullName") => {
  const name1 = a[nameField]?.toLowerCase() || "";
  const name2 = b[nameField]?.toLowerCase() || "";

  return name1.localeCompare(name2);
};
